import React, { useContext, useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useNavigate } from "react-router-dom";
import Shopkeeper from "../../Services/shopkeeperServices";
import TitleHeader from "../accounts/Components/TitleHeader";
import ExportComponents from "../../Components/ExportComponents";
import { Popconfirm, Table as TB } from "antd";
import { permit } from "../../helpers/Authorize";
import { Delete, Edit } from "../../Components/Icons/Buttons";
import { userPermissions } from "../../config/EnVariables";
import { AuthContext } from "../../Auth/Context/AuthContext";
import callApi from "../../helpers/callApi";
function ShopKeeperList(props) {
  const { user } = useContext(AuthContext);
  const columns = [
    {
      title: "S.no",
      dataIndex: "sno",
      responsive: ["sm"],
    },
    {
      title: "Name",
      dataIndex: "name",

      responsive: ["sm"],
    },
    {
      title: "Phone",
      dataIndex: "phone",

      responsive: ["sm"],
    },
    {
      title: "Address",
      dataIndex: "address",
      width: "20%",
      responsive: ["sm"],
    },
    {
      title: "Actions",
      dataIndex: "action",
      responsive: ["sm"],
    },
    {
      index: "actions",
      text: "Action",
      formatter: (cellContent, row) => {
        return (
          <div>
            <button
              style={{ backgroundColor: "transparent", border: "0px" }}
              onClick={() => navigate(`/shopkeeper-details/${row._id}`)}
            >
              <img src="/assets/img/icons/eye.svg" alt="img" />
            </button>
            <button
              style={{ backgroundColor: "transparent", border: "0px" }}
              onClick={() => editShopKeeper(row._id)}
            >
              <img src="assets/img/icons/edit.svg"></img>
            </button>
            <button
              style={{ backgroundColor: "transparent", border: "0px" }}
              onClick={() => deleteShopKeeper(row._id)}
            >
              <img src="assets/img/icons/delete.svg"></img>
            </button>
          </div>
        );
      },
    },
  ];
  const navigate = useNavigate();
  const [shopKeeperList, setShopKeeperList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [filters, setFilters] = useState();
  let pageSizeValue = 20;
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: pageSizeValue,
      showSizeChanger: true,
      pageSizeOptions: [10, 15, 20, 25, 30, 35, 40, 45, 50, 100],
    },
  });
  const handleTableChange = async (pagination, filter, sorter) => {
    pageSizeValue = pagination.pageSize;
    setTableParams({ pagination, filter, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setShopKeeperList([]);
    }
    const params = { size: pagination.pageSize };
    paging.current = pagination.current;
    if (filters) {
      let fils = filters;
      fils.page = pagination.current;
      fils.pageSize = pageSizeValue;
      await fetchData(fils);
    } else {
      await fetchData(params);
    }
  };
  // const onFilter = async (values) => {
  //   setIsFilter(true);
  //   setTableParams({
  //     ...tableParams,
  //     pagination: {
  //       ...tableParams.pagination,
  //       current: 1,
  //     },
  //   });
  //   let params = {
  //     page: 1,
  //   };
  //   paging.current = 1;
  //   params.institute_enrollment__institute = values.filterInstitute?.value;
  //   params.main_province = values.main_province?.value;

  //   setFilters(params);
  //   localStorage.setItem("shopParams", JSON.stringify(params));
  //   fetchData(params);
  // };
  const editShopKeeper = (id) => {
    navigate(`/edit-shopkeeper/${id}`);
  };

  const deleteShopKeeper = async (id) => {
    setLoading(true);
    await Shopkeeper.remove(id)
      .then(() => {
        setLoading(false);
        getShopKeeperList();
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  const getShopKeeperList = async () => {
    setLoading(true);
    await Shopkeeper.getAll()
      .then((data) => {
        setShopKeeperList(data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };
  let paging = { current: 1 };
  async function fetchData(params = {}) {
    setLoading(true);
    let endpoint = `shopkeepers/?branchId=${user.branchId}`;
    const params1 = {
      ...params,
      page: !isFilter ? paging.current - 1 : params.page - 1 || 0,
      size: pageSizeValue || null,
    };
    try {
      const response = await callApi(endpoint, null, null, params1);
      if (response.data && response.status === 200) {
        setShopKeeperList(response.data);
        const totalStudents = response.headers.get("x-total-count");
        setTableParams({
          ...tableParams,
          pagination: {
            ...tableParams.pagination,
            total: totalStudents,
            current: params1.page + 1,
            pageSize: pageSizeValue,
          },
        });
      } else {
        console.log("students error");
      }
    } catch (error) {
      console.log("error: ", error);
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    // getShopKeeperList();
    fetchData();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <TitleHeader title={`Shopkeeper List-(${shopKeeperList?.length})`} />
          <div class="page-btn">
            <a href="add-shopkeeper" class="btn btn-added">
              <img src="/assets/img/icons/plus.svg" alt="img" class="me-2" />
              Add Shop Keeper
            </a>
          </div>
          <div class="card">
            <div class="card-body">
              <div class="table-top">
                <div class="search-set">
                  <div class="search-path">
                    <a class="btn btn-filter" id="filter_search">
                      <img src="/assets/img/icons/filter.svg" alt="img" />
                      <span>
                        <img src="/assets/img/icons/closes.svg" alt="img" />
                      </span>
                    </a>
                  </div>
                  <div class="search-input">
                    <a class="btn btn-searchset">
                      <img src="/assets/img/icons/search-white.svg" alt="img" />
                    </a>
                  </div>
                </div>

                <ExportComponents
                  excelData={shopKeeperList}
                  fileName="Shopkeepers.xlsx"
                />
              </div>

              <div class="card" id="filter_inputs">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <input type="text" placeholder="Enter User Name" />
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <input type="text" placeholder="Enter Phone" />
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <input type="text" placeholder="Enter Email" />
                      </div>
                    </div>
                    <div class="col-lg-2 col-sm-6 col-12">
                      <div class="form-group">
                        <select class="select">
                          <option>Disable</option>
                          <option>Enable</option>
                        </select>
                      </div>
                    </div>
                    <div class="col-lg-1 col-sm-6 col-12 ms-auto">
                      <div class="form-group">
                        <a class="btn btn-filters ms-auto">
                          <img
                            src="/assets/img/icons/search-whites.svg"
                            alt="img"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <BootstrapTable
                bootstrap4
                bordered={false}
                keyField="_id"
                data={shopKeeperList}
                columns={columns}
                selectRow={{ mode: "checkbox" }}
              /> */}

              <TB
                class="table-responsive table"
                style={{ fontSize: 25, fontFamily: "arial" }}
                size="large"
                columns={columns}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
                loading={loading}
                dataSource={shopKeeperList?.map((item, index) => ({
                  key: item._id,
                  sno: index + 1,
                  name: <p>{item.name}</p>,
                  phone: item.phone,
                  address: item.address,
                  shop: "-",
                  action: (
                    <div>
                      <button
                        style={{
                          backgroundColor: "transparent",
                          border: "0px",
                        }}
                        onClick={() =>
                          navigate(`/shopkeeper-details/${item.id}`)
                        }
                      >
                        <img src="/assets/img/icons/eye.svg" alt="img" />
                      </button>
                      {permit(userPermissions.update) && (
                        <Edit onClick={() => editShopKeeper(item.id)} />
                      )}

                      {permit(userPermissions.delete) && (
                        <Popconfirm
                          title="Delete the Shopkeeper"
                          description="Are you sure to delete this Shopkeeper?"
                          onConfirm={() => deleteShopKeeper(item.id)}
                          okText="Yes"
                          cancelText="No"
                        >
                          <Delete />
                        </Popconfirm>
                      )}
                    </div>
                  ),
                }))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ShopKeeperList;
